import "./main.scss";

import { Hook, SheerIdJsApi } from "./lib/types/types";

import { VerificationFormEs5 } from "./es5Bindings/VerificationFormEs5";
import { getMessages } from "./lib/intl/intl";
import { resetViewModel, setViewModel } from "./lib/VerificationService/ViewModel";
import { resetOptions, setOptions } from "./options/options";
import { refreshStore, resetStore } from "./lib/VerificationService/VerificationServiceStore";
import { getMetadata, resetMetadata, setMetadata } from "./lib/metadata/metadata";
import { conversion } from "./lib/conversion/conversion";
import {
  overrideComponent,
  resetOverriddenComponents,
} from "./lib/componentOverride/componentOverride";
import { addHook, hooks } from "./lib/hooks";
import { collectDeviceProfile } from "./lib/fraud/fraud";
import { postVerificationSizeUpdates } from "./lib/frames/postMessageFromIframe";
import { setProgramTheme } from "./lib/VerificationService/ProgramTheme/ProgramTheme";

// Modify window interface to allow the SheerID object.
declare global {
  interface Window {
    /**
     * Needed to maintain the ability to set sheerid.hooks globally before loading the jslib.
     */
    sheerId: { hooks: Hook[] };

    NREUM: any; // New Relic
    gtag: any; // Google Analytics (GA4)
    IPQ: any; // IPQS
    Startup: any; // IPQS

    sheerIdInstallType: string; // for custom programs to tell the jslib which install type they are using. Use "npm_package" for offers.sheerid.com projects
    sheerIdProjectSha: string; // for custom programs to tell the jslib what the git sha of the project is. Do not use the jslib git sha.
  }
}

// Implements the SheerIdJsApi interface
const thisJslib: SheerIdJsApi = {
  getMessages,
  setViewModel,
  resetViewModel,
  setOptions,
  resetOptions,
  refreshStore,
  setMetadata,
  getMetadata,
  resetMetadata,
  conversion,
  overrideComponent,
  resetOverriddenComponents,
  postVerificationSizeUpdates,
  addHook,
  hooks,
  VerificationForm: VerificationFormEs5,
  collectDeviceProfile,
  resetStore,
  setProgramTheme,
};

export default thisJslib;
